export class FormDataContent {
    id: string
    value: string | any
    another: string
    type: string
    score: number
    scoreMax: number
}
